import axios from 'axios'
import { toast } from '@pc/components/Toast'

const buttonSelector = '.js-favorite-button'
let offerId: string | undefined

function add() {
  if (offerId === undefined) return

  const target = document.querySelectorAll<HTMLElement>(`${buttonSelector}[data-offer-id="${offerId}"]`)
  if (target.length === 0) return

  target.forEach((el) => {
    el.innerHTML = '<i class="icon-minus-o"></i>&nbsp;キープから外す'
    el.dataset.favoriteAction = 'delete'
  })

  axios
    .get('/favorite/add', {
      params: { id: offerId }
    })
    .then(() => {
      toast('キープしました', 2400)
      count()
    })
    .catch((err) => {
      console.log(err.message)
    })
}

function del() {
  if (offerId === undefined) return

  const target = document.querySelectorAll<HTMLElement>(`${buttonSelector}[data-offer-id="${offerId}"]`)
  if (target.length === 0) return

  target.forEach((el) => {
    el.innerHTML = '<i class="icon-star-o"></i>&nbsp;キープに追加'
    el.dataset.favoriteAction = 'add'
  })

  axios
    .get('/favorite/delete', {
      params: { id: offerId }
    })
    .then(() => {
      toast('キープから削除しました', 2400)
      count()
    })
    .catch((err) => {
      console.log(err.message)
    })
}

function count() {
  axios
    .get('/favorite/number')
    .then((res) => {
      const num = res.data.count
      const buttonLinks = document.querySelectorAll<HTMLElement>('.js-favorite-button-link')
      const counterElements = document.querySelectorAll<HTMLElement>('.js-favorite-counter')
      const fixedButton = document.getElementById('js-fixed-favorite-num')

      if (buttonLinks.length > 0) {
        buttonLinks.forEach((el) => {
          el.classList.toggle('is-link-disabled', num === 0)
        })
      }

      if (counterElements.length > 0) {
        counterElements.forEach((el) => {
          el.classList.toggle('is-hide', num === 0)
          el.innerText = num
        })
      }

      if (fixedButton !== null) {
        fixedButton.innerText = num
      }
    })
    .catch((err) => {
      console.log(err.message)
    })
}

export function keep() {
  const buttons = document.querySelectorAll(buttonSelector)
  if (buttons.length === 0) return

  buttons.forEach((button) => {
    button.addEventListener('click', (e) => {
      const self = e.currentTarget as HTMLElement
      const action = self.dataset.favoriteAction
      offerId = self.dataset.offerId

      if (action === 'add') {
        add()
        return
      }
      if (action === 'delete') {
        del()
        return
      }
      if (action === 'link') {
        window.location.href = '/works/keepings'
      }
    })
  })
}
